import { z } from 'zod';
import { CrossingDirection, VehicleClass } from './round.ts';
import { CameraAliasId, CrossingEventId, GameRoundId, MediaPts, TrackId, UtcInstant } from './primitives.ts';

export const CrossingEvent = z.object({
  eventId: CrossingEventId,
  gameRoundId: GameRoundId,
  cameraAlias: CameraAliasId,
  sourceEpoch: z.string().min(1).max(128),
  trackId: TrackId,
  lineId: z.string().min(1).max(64),
  direction: CrossingDirection,
  vehicleClass: VehicleClass,
  confidence: z.number().min(0).max(1),
  framePts: MediaPts,
  /** Trusted capture time when the source provides one; null when unknown. */
  capturedAt: UtcInstant.nullable(),
  modelVersion: z.string().min(1),
  configVersion: z.string().min(1),
  evidenceRef: z.string().min(1).max(512),
  /** Set when tracker/line logic could not rule out a duplicate or ambiguous crossing. */
  uncertain: z.boolean(),
  /** Where the event came from. SIMULATION events are never produced by video inference. */
  origin: z.enum(['VIDEO_INFERENCE', 'SIMULATION_FIXTURE']),
});
export type CrossingEvent = z.infer<typeof CrossingEvent>;
